import { addStyles } from 'ethcss'
import grid from 'blocks.simple/grid/grid.jcss'
import { mediaCSS } from 'theme/media'
import { IStyles } from '../../../theme'
import { color } from 'theme/tokens/color'

const deviceSettingsVideoPlayer: IStyles = {
    optionsWrapper: {
        ...grid.fullWidth,
    },
    textArea: {
        ...grid.row,
        ...grid.w25,
        [mediaCSS.tab]: {
            ...grid.w45,
        },
        [mediaCSS.tabMini]: {
            ...grid.w100,
        },
    },
    switchWrapper: {
        display: 'flex',
    },
    switchCaption: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 14,

        span: {
            marginRight: 6,
        },
    },
    tip: {
        fontSize: 12,
    },
    hint: {
        color: color.fontDarkMedium,
        marginTop: 8,
    },
}

addStyles(deviceSettingsVideoPlayer)
export default deviceSettingsVideoPlayer
